import * as _4 from 'lodash4';
import { PathModalService } from './../path_modal_service';

export class PathAutoCompleteModalController {
  private institutionName: string;

  constructor(private ngPathModalService: PathModalService, private appConfigModel: any) {}

  $onInit() {
    this.institutionName = _4.isEmpty(this.appConfigModel.getConfigProperty('core-inst_name'))
      ? 'the school'
      : this.appConfigModel.getConfigProperty('core-inst_name');
  }
}

export class PathAutoCompleteModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-todos/src/modals/path_auto_complete_modal/what_is_auto_complete_modal.html';
  public controller: any = PathAutoCompleteModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/modals/path_auto_complete_modal/what_is_auto_complete_modal.ts